import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

const routes: Routes = [];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
  providers: []
})
export class RiderRoutingModule { }



// WEBPACK FOOTER //
// ./src/app/pages/rider/rider-routing.module.ts